import { isPhotoTombstoned } from './isPhotoTombstoned';

const STOCK_PHOTO_PATH = '/default-assets/';

/**
 * Resolves the best photo URL from multiple sources, preferring real user uploads over stock template images.
 *
 * Each website layout stores separate header presentation data. When users switch layouts or upload photos
 * on different layouts, one source may have the real photo while another has stock templates.
 *
 * Tombstoned photos (soft-deleted, url="") are treated as absent and skipped.
 *
 * @param eventPhoto - Photo from event.photo (legacy field, may have old uploads)
 * @param headerLayoutPhoto - Photo from layout-specific header presentation data
 * @param placeholderUrl - Fallback URL when no real photo exists
 * @returns The best available photo URL
 */
export function resolvePhotoUrl(eventPhoto: { url?: string } | null | undefined, headerLayoutPhoto: { url?: string } | null | undefined, placeholderUrl: string): string {
  const safeEventPhoto = isPhotoTombstoned(eventPhoto) ? null : eventPhoto;
  const safeHeaderPhoto = isPhotoTombstoned(headerLayoutPhoto) ? null : headerLayoutPhoto;
  const isHeaderPhotoStock = safeHeaderPhoto?.url?.includes(STOCK_PHOTO_PATH);
  const userPhotoUrl = isHeaderPhotoStock ? safeEventPhoto?.url : safeHeaderPhoto?.url;
  return userPhotoUrl ?? safeEventPhoto?.url ?? placeholderUrl;
}
